import React from 'react';
import { Option, OptionList } from 'components/contents/Option';
import { slugs } from 'components/works/api';
import { Content, ContentsCategory } from '../lib/FL';
import BasicContentCard from '../components/contents/BasicContentCard';
import ContentCard from '../components/contents/ContentCard';
import styles from './ContentsPage.module.scss';

type Props = {
  basicContents?: Content[];
  contentCategories?: ContentsCategory[];
};

const options: Option[] = [
  {
    title: 'トップページオリジナルデザイン',
    image: 'https://contents.rals.biz/assets/formatline/catalog/img/img_custom_original.jpg',
    icons: ['popular', 'recommend'],
    description:
      'トップページのデザインをオリジナルで制作！\nフォーマット型ホームページでありながら、より自由度の高い御社だけのホームページ制作をできます。\n不動産、建築、リフォームの他、売却査定や物件管理など、事業内容に合わせて制作可能です。',
    price: 300000,
    isLowestPrice: false,
    terms: [slugs.option.topOriginal],
    perPriceText: '',
    demoUrl: '',
  },
  {
    title: 'ファーストビューカスタム',
    image: 'https://contents.rals.biz/assets/formatline/catalog/img/img_custom_fv.jpg',
    icons: ['popular', 'recommend'],
    description:
      'トップページのファーストビューのみオリジナルデザインで制作！よりイメージに沿ったデザインに。',
    price: 30000,
    isLowestPrice: false,
    terms: [slugs.option.fvCustom],
    perPriceText: '',
    demoUrl: '',
  },
  {
    title: 'スライド画像追加',
    image: 'https://contents.rals.biz/assets/formatline/catalog/img/img_custom_slide.jpg',
    icons: ['popular', 'recommend'],
    description:
      'ファーストビュー画像をスライド式にすることで、複数の商品アピール・イメージの強化が可能です。',
    price: 10000,
    isLowestPrice: false,
    terms: [slugs.option.fvMultipleImage],
    perPriceText: '1枚につき',
    demoUrl: '',
  },
  {
    title: 'SNS・外部ブログ表示枠の設置',
    image: 'https://contents.rals.biz/assets/formatline/catalog/img/img_custom_sns.jpg',
    icons: ['popular', 'recommend'],
    description:
      'X（旧Twitter）、Facebook、Instagramの各SNSの投稿や、お手持ちのブログの投稿記事をトップページへ表示します。',
    price: 10000,
    isLowestPrice: false,
    terms: [slugs.option.sns],
    perPriceText: '1枠につき',
    demoUrl: '',
  },
  {
    title: '物件検索枠の設置',
    image: 'https://contents.rals.biz/assets/formatline/catalog/img/img_custom_search.jpg',
    icons: ['trial', 'recommend'],
    description:
      'トップページ上で探したい物件の条件を絞り込み・検索！お客様にスムーズに物件を閲覧いただけます。',
    price: 30000,
    isLowestPrice: false,
    terms: [],
    perPriceText: '',
    demoUrl: 'https://www.rals.co.jp/bukken/demo/search/',
  },
  {
    title: 'こだわり物件検索ボタン',
    image: 'https://contents.rals.biz/assets/formatline/catalog/img/img_custom_btn.png',
    icons: ['recommend'],
    description:
      '「ペット可物件」など、条件指定の検索リンクを、よりユーザーに注目されやすい写真（もしくはイラスト）付きボタンに変更できます。',
    price: 30000,
    isLowestPrice: false,
    terms: [],
    perPriceText: '',
    demoUrl: '',
  },
];

const ContentsPage: React.FC<Props> = ({ basicContents, contentCategories }) => (
  <main className={styles.content}>

    <p className={styles.tax}>税抜価格表示となっております。別途消費税が掛かります。</p>
    <section className={styles.categories}>
      <h2 className={styles.categories__title}>
        基本5点セット<span className={styles.categories__title_note}>※ホームぺージのベースとなるコンテンツです。</span>
      </h2>
      <ul className={`${styles.cards} ${styles.cards_basic}`}>
        {basicContents?.map((content) => (
          <BasicContentCard key={content.en_name} content={content} />
        ))}
      </ul>
    </section>
    <section className={styles.categories}>
      <h2 className={styles.categories__title}>カスタマイズオプション</h2>
      <OptionList options={options} />
    </section>
    {contentCategories?.map(({ id, name, contents }) => (
      <section className={styles.categories} key={id}>
        <h2 className={styles.categories__title}>{name}</h2>
        <ul className={styles.cards}>
          {contents.map((content) => (
            <ContentCard key={content.en_name} content={content} />
          ))}
        </ul>
      </section>
    ))}
  </main>
);

ContentsPage.defaultProps = {
  basicContents: undefined,
  contentCategories: undefined,
};

export default ContentsPage;
